export const API_IMG = "https://image.tmdb.org/t/p/original/";
export const API_IMG_W500 = "https://image.tmdb.org/t/p/w500/";